import VueTk from '@moke/vue-tk'
export default async () => {
  // 设置中间件
  VueTk.$tkAjaxGlobal.preMidware = [
    (config, next) => {
      let classNames = ['_SmsCode']
      if (config.expect === 'data') {
        next(config)
        return
      }
      if (config.url === '/batch' && config.method === 'post') {
        for (let i in config.data.requests) {
          let item = config.data.requests[i]
          let className = item.path.match(/\/classes\/(\w+)/) ? item.path.match(/\/classes\/(\w+)/)[1] : ''
          if (!classNames.includes(className)) {
            if (!item.body.where) {
              item.body.where = {
                isDeleted: false
              }
            }
            if (item.body.where) {
              item.body.where.isDeleted = false
            }
          }
        }
        next(config)
        return
      }
      if (config.method === 'put' || config.method === 'delete') {
        next(config)
        return
      }
      let match = config.url.match(/\/classes\/(\w+)/)
      if (!match || classNames.includes(match[1])) {
        return next(config)
      }
      if (config.method === 'get') {
        VueTk.tkHelper.set(config, 'params.where.isDeleted', false)
      } else if (config.method === 'post') {
        VueTk.tkHelper.set(config, 'data.isDeleted', false)
      }
      next(config)
    }
  ]
}
